import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { ServiceNoteIssueRequestHdrContainerModel } from '../../../../../../models/aggregates/erp/rma';
import { Core2Config } from '../../shared/core2Config';
import { HttpClient } from '@angular/common/http';
import { ApiVisa, BasicApiResponseModel } from '../../shared';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class ServiceNoteIssueRequestHdrService extends BaseApiTemplateService<ServiceNoteIssueRequestHdrContainerModel> {

  readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/issue-request-hdrs/backoffice-ep';
  customUrl;
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/issue-request-hdrs/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/issue-request-hdrs/backoffice-ep';
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/issue-request-hdrs/'+ Core2Config.LOGIN_ENTITY_EP_SUFFIX;
    this.customUrl =  Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/issue-request-hdrs';
    this.httpClient = http;
  }

   UpdateApprovalStatus(guid: string,dtoObject: any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      this.customUrl = visa.api_domain_url + this.customUrl + '/update-approval-status/backoffice-ep/' + guid;
    }
    return this.httpClient.put<BasicApiResponseModel<any>>(
      this.customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

}